"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _base = _interopRequireDefault(require("../../style/themes/base"));

var _icon = _interopRequireDefault(require("../../components/icon/icon.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ValidationIconStyle = _styledComponents.default.span`
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
  border: 0;
  outline: none;

  ${_icon.default}:before {
    color: ${({
  validationType,
  theme
}) => theme.colors[validationType]};
  }

  ${_icon.default}:focus {
    outline: solid 2px ${({
  theme
}) => theme.colors.focus};
  }

  ${_styledSystem.margin}
`;
ValidationIconStyle.defaultProps = {
  validationType: "error",
  theme: _base.default
};
var _default = ValidationIconStyle;
exports.default = _default;